"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
function usePlayerScript(setIsPlayerReady, setIsPlayerUnsupported, document, window) {
  (0, _react.useEffect)(function () {
    /**
     * Importing via NPM did not work in context of storybook or a CRA React app, so loading via script
     */
    var script = document.createElement('script');
    script.src = 'https://player.live-video.net/1.0.0/amazon-ivs-player.min.js';
    script.async = true;
    document.body.appendChild(script);
    script.onload = function () {
      // eslint-disable-next-line no-undef
      if (window.IVSPlayer.isPlayerSupported) {
        setIsPlayerReady(true);
      } else {
        setIsPlayerUnsupported(true);
      }
    };
    return function () {
      document.body.removeChild(script);
    };
  }, [setIsPlayerReady, setIsPlayerUnsupported]);
}
var _default = exports["default"] = usePlayerScript;